import admin from './admin'
import consultation from './consultation'
import version from './version'

// Array of sections
export default [...consultation, ...admin, ...version]
